exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2W5xJUmlvQKbkSfClhLSEm{padding-inline-start:20px;padding-inline-end:20px}@media only screen and (min-width: 480px){._2W5xJUmlvQKbkSfClhLSEm{padding-inline-start:36px;padding-inline-end:36px}}@media only screen and (min-width: 1280px){._2W5xJUmlvQKbkSfClhLSEm{padding-inline-start:52px;padding-inline-end:52px}}._3ZV2gFbQdLbZLI4WQIhJ1K{margin-inline-start:20px;margin-inline-end:20px}@media only screen and (min-width: 480px){._3ZV2gFbQdLbZLI4WQIhJ1K{margin-inline-start:36px;margin-inline-end:36px}}@media only screen and (min-width: 1280px){._3ZV2gFbQdLbZLI4WQIhJ1K{margin-inline-start:52px;margin-inline-end:52px}}._1ROkiekCw04m3LrdJprhEh{display:none}.RQqecfpkC9FEZTjhpENW4{top:0;bottom:0;width:100dvw;height:100dvh;position:fixed;overflow:hidden}", ""]);

// exports
exports.locals = {
	"navbarHeight": "72px",
	"grid-sides": "_2W5xJUmlvQKbkSfClhLSEm",
	"gridSides": "_2W5xJUmlvQKbkSfClhLSEm",
	"grid-sides-margins": "_3ZV2gFbQdLbZLI4WQIhJ1K",
	"gridSidesMargins": "_3ZV2gFbQdLbZLI4WQIhJ1K",
	"hidden": "_1ROkiekCw04m3LrdJprhEh",
	"video-stories-overlay": "RQqecfpkC9FEZTjhpENW4",
	"videoStoriesOverlay": "RQqecfpkC9FEZTjhpENW4"
};